import "./style.scss";
import { ReactComponent as IconBack } from "../../assets/img/icons/icon_arrow-Left.svg";
import { ReactComponent as IconAlert } from "../../assets/img/icons/icon_Warning.svg";
import { ReactComponent as IconShield } from "../../assets/img/icons/icon_shield-Locked.svg";

import React, { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "shared/ui/Button";
import { Button_Style, Button_Type } from "shared/ui/Button/Button";
import { getSubscription } from "features/account";
import { UserContext } from "features/account";
import NotificationsList from "../NotificationsList";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

type PageHeaderProps = {
  children?: React.ReactNode;
  showBackBtn?: boolean;
  title?: string;
  description?: string;
  protectAlert?: boolean;
  notification?: boolean;
  notificationFilter?: 'id-assistant' | 'id-locker' | 'identity-documents' | 'all'
};

const PageHeader: FC<PageHeaderProps> = ({
         children,
         showBackBtn= true,
  title,
  notification,
  protectAlert = true,
  description,
  notificationFilter = 'all'
}) => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const type = user?.type;


  const [hasOffer, sethasOffer] = useState<any>(null);
  useEffect(() => {
    const checkOffer = async () => {
      try {
        const response = await getSubscription(type, user?.email);
        if (response.data.offrePurchase && response.data.offrePurchase.id > 1) {
          sethasOffer(true);
        }
        else{
          sethasOffer(false);
        }

      } catch (error) {
        console.log(error);
      }
    };

    if (user) {
      checkOffer();
    }
  }, [user, type]);

  const activeIDProtectDarkWeb = () => {
    navigate(`${type === "partner" ? "/professionnels" : "/particuliers"}/id-tracker-pricing`)
  }

    return (
      <div className="PageHeader shadow">
        <div className={"d-flex gap-1 justify-content-center align-items-center"}>
          <div className={`d-flex gap-05 flex-wrap-reverse`}>
            <div className="d-flex flex-row flex-wrap gap-1 justify-content-center align-items-center">
              {showBackBtn && (
                <IconBack
                  className="PageHeader__icon"
                  fill={"#9FC1EF"}
                  width={20}
                  onClick={() => navigate(-1)}
                />
              )}
              <div
                className={"PageHeader__title bold pointer hover:shadow"}
                onClick={() => navigate(0)}
              >
                {title?.toUpperCase()}
              </div>
              {description && (
                <>
                  <div className={"text-gray-500"}>|</div>
                  <div className={"text-muted-foreground text-sm"}>{description}</div>
                </>
              )}
            </div>
            {protectAlert && (
              <>
                {hasOffer === false ? (
                  <div
                    className={`shadow show tag-icon tag-error rounded-lg d-flex flex-row justify-content-center align-items-center ${isMobile ? 'IDTrackerMobile': 'IDTrackerWeb'}`}>
                    <IconAlert
                      fill={"#ffffff"}
                      height={20}
                      className="PageHeader__icon"
                      width={20}
                    />
                    <span className={"text-sm bold"}>Protection Dark Web Inactive</span>
                    <Button
                      label={"ACTIVER"}
                      type={Button_Type.WHITE}
                      style={Button_Style.SOLID} className={"rounded-lg mb-1 shadow"}
                      onClick={activeIDProtectDarkWeb}
                    />
                  </div>
                ): (
                  <div
                    className={`shadow show tag-icon tag-success rounded-lg d-flex flex-row flex-wrap justify-content-center align-items-center ${isMobile ? 'IDTrackerMobile': 'IDTrackerWeb'}`}>
                    <IconShield
                      fill={"#148c48"}
                      height={20}
                      className="PageHeader__icon"
                      width={20}
                    />
                    <span className={"text-sm bold text-primary pr-2"}>Protection Dark Web <span
                      className={"text-success"}>Activée</span></span>
                  </div>
                )}

              </>
            )}
          </div>
        </div>
        {!isMobile && notification && (
          <NotificationsList filter={notificationFilter!} limit={10}/>
        )}
      </div>
    );
}

export default PageHeader;
